import {z} from '@hono/zod-openapi';

import {amount} from './amount';
import {ArticleAbcXyzSchema} from './ArticleAbcXyzSchema';
import {ArticleIssueChannelSchema} from './ArticleIssueChannelSchema';
import {ArticleStatisticsMonthSchema} from './ArticleStatisticsMonthSchema';
import {ArticleStockAgingBucketSchema} from './ArticleStockAgingBucketSchema';

export const ArticleStatisticsResponseSchema = z
  .object({
    asOf: z.string().date(),
    capturedAt: z.string(),
    timezone: z.string(),
    averageInventoryQuantity: amount.nullable(),
    stockAging: z.array(ArticleStockAgingBucketSchema).length(5),
    issueChannels: z.array(ArticleIssueChannelSchema).length(8),
    abcXyz: ArticleAbcXyzSchema,
    months: z.array(ArticleStatisticsMonthSchema).length(24),
  })
  .openapi('ArticleStatisticsResponse');

export type ArticleStatisticsResponse = z.infer<typeof ArticleStatisticsResponseSchema>;
